<template>
  <div>
    <h1>Log In</h1>
    <div
      v-if="newSignup"
      class="alert alert-info"
    >
      Thanks for signing up! <br><br>
      Please continue by logging in with the information
      you provided in the registration form.
    </div>
    <login-form />
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  metaInfo: {
    title: 'Log In',
  },
  components: {
    LoginForm,
  },
  data() {
    return {
      newSignup: this.$route.query.newSignup,
    };
  },
};
</script>

<style lang="scss" scoped>
  h1 {
    text-align: center;
  }
  .alert-info {
    border: 1px solid grey;
    background: slategray;
    color: white;
  }

  @media (min-width: 1024px) {
    h1 {
      text-align: left;
    }
  }
</style>
